import { render } from "./UserTopBrands.vue?vue&type=template&id=61a420f6"
import script from "./UserTopBrands.vue?vue&type=script&lang=js"
export * from "./UserTopBrands.vue?vue&type=script&lang=js"

import exportComponent from "/Users/zayed-lune/Desktop/Lunedata/lune-dashboard/dashboard-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/UserTopBrands.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "61a420f6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('61a420f6', __exports__)) {
    console.log('reload')
    api.reload('61a420f6', __exports__)
  }
  
  module.hot.accept("./UserTopBrands.vue?vue&type=template&id=61a420f6", () => {
    console.log('re-render')
    api.rerender('61a420f6', render)
  })

}


export default __exports__